import { render, staticRenderFns } from "./PositionPlan.vue?vue&type=template&id=70a6e196"
import script from "./PositionPlan.vue?vue&type=script&lang=js"
export * from "./PositionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports